import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/auth/slices/authSlice";
import userAppSettingsReducer from "../features/settings/slices/userAppSettingsSlice";
import emailNotificationsReducer from "@/features/adminEmailNotifications/slices/emailNotificationSlice";
import chapterActivityReducer from "@/features/myChapterActivity/slices/chapterActivitySlice";
import myEmailNotificationReducer from "@/features/myEmailNotifications/slices/myEmailNotificationSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  userAppSettings: userAppSettingsReducer,
  emailNotifications: emailNotificationsReducer,
  chapterActivity: chapterActivityReducer,
  myEmailNotifications: myEmailNotificationReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
